import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "dropdown", "results", "selected", "hiddenField", "selectedName", "selectedDetail"]
  static values = {
    items: Array,
    placeholder: String
  }

  connect() {
    this.selectedItem = null
    document.addEventListener("click", this.handleClickOutside.bind(this))
  }

  disconnect() {
    document.removeEventListener("click", this.handleClickOutside.bind(this))
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.closeDropdown()
    }
  }

  search() {
    const query = this.inputTarget.value.trim().toLowerCase()

    if (query.length === 0) {
      this.closeDropdown()
      return
    }

    const filtered = this.itemsValue.filter(item =>
      item.label.toLowerCase().includes(query)
    ).slice(0, 10)

    this.renderResults(filtered)
    this.openDropdown()
  }

  renderResults(items) {
    if (items.length === 0) {
      this.resultsTarget.innerHTML = `
        <div class="px-3 py-2 text-sm text-beige-500 italic">No matches found</div>
      `
      return
    }

    this.resultsTarget.innerHTML = items.map(item => `
      <button type="button"
              class="w-full text-left px-3 py-2 text-sm hover:bg-beige-100 transition-colors flex items-center gap-2"
              data-action="click->attachment-select#selectItem"
              data-id="${item.id}"
              data-label="${this.escapeHtml(item.label)}"
              data-detail="${this.escapeHtml(item.detail || '')}">
        ${item.image ? `<img src="${item.image}" class="w-8 h-10 object-cover rounded shadow-sm shrink-0" alt="">` : ''}
        <div class="min-w-0 flex-1">
          <p class="font-medium text-beige-900 truncate">${this.escapeHtml(item.label)}</p>
          ${item.detail ? `<p class="text-xs text-beige-500 truncate">${this.escapeHtml(item.detail)}</p>` : ''}
        </div>
      </button>
    `).join('')
  }

  escapeHtml(str) {
    if (!str) return ''
    const div = document.createElement('div')
    div.textContent = str
    return div.innerHTML
  }

  selectItem(event) {
    const button = event.currentTarget
    const id = button.dataset.id
    const label = button.dataset.label
    const detail = button.dataset.detail

    this.selectedItem = { id, label, detail }
    this.hiddenFieldTarget.value = id
    this.selectedNameTarget.textContent = label
    if (this.hasSelectedDetailTarget && detail) {
      this.selectedDetailTarget.textContent = detail
    }

    this.inputTarget.value = ""
    this.closeDropdown()
    this.selectedTarget.classList.remove("hidden")
    this.inputTarget.classList.add("hidden")
  }

  clearSelection() {
    this.selectedItem = null
    this.hiddenFieldTarget.value = ""
    this.selectedTarget.classList.add("hidden")
    this.inputTarget.classList.remove("hidden")
    this.inputTarget.focus()
  }

  openDropdown() {
    this.dropdownTarget.classList.remove("hidden")
  }

  closeDropdown() {
    this.dropdownTarget.classList.add("hidden")
  }

  focus() {
    if (!this.selectedItem) {
      this.inputTarget.focus()
    }
  }
}
